/* fiveaven : recherche intelligente (Copie Andy).
   1. Volet de recherche : la liste « Produits » renvoyée par Shopify est remplacée par celle du moteur fv-recherche-moteur.js
      (fautes de frappe, mots incomplets, français / anglais, effets, actifs), avec des « Produits proches » s'il y a peu de
      résultats. Les suggestions, pages, collections et articles de Shopify restent tels quels.
   2. Page /search (section fv-recherche) : mêmes résultats, filtres Marques / Type de soin, cartes identiques aux collections.
   Si l'index ne se charge pas, tout retombe sur la recherche Shopify d'origine.
   Racine de la page de résultats : data-fvs / classes fvs__ (distinctes du récapitulatif du panier, data-fvr / fvr-).
   Le moteur (fv-recherche-moteur.js, 21 Ko) n'est plus chargé sur toutes les pages : il arrive avec l'index, à la première
   approche de la recherche (survol de la loupe, champ de saisie, volet, page /search). */
(function () {
  "use strict";
  var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var URL_INDEX = RACINE + "collections/all?view=fv-index";
  var SCRIPT = document.currentScript;
  var URL_MOTS = (SCRIPT && SCRIPT.getAttribute("data-mots")) || ""; // mots des clientes (préparés par IA)
  // adresse du moteur : attribut data-moteur (asset_url, layout/theme.liquid) ; à défaut, voisine de ce fichier
  var URL_MOTEUR = (SCRIPT && SCRIPT.getAttribute("data-moteur")) || (SCRIPT && SCRIPT.src ? SCRIPT.src.replace(/fv-recherche\.js(\?[^#]*)?(#.*)?$/, "fv-recherche-moteur.js") : "");
  /* fiveaven (17/10/2026) : prix et stocks à jour dans la recherche (Andy : prix modifiés visibles sur les fiches mais pas dans la
     recherche) : l'index n'est plus gardé que 1 min dans le navigateur (au lieu de 30), la page de résultats le recharge toujours,
     et l'adresse change chaque minute pour ne pas recevoir une copie ancienne du cache. Clé v4 : les anciens index sont ignorés. */
  var CLE = "fv-recherche-index-v4", DUREE = 60 * 1000;
  function urlIndex() { return URL_INDEX + "&fv=" + Math.floor(Date.now() / 60000); }
  var fetchOrig = window.fetch.bind(window);
  var index = null, chargement = null, moteurPret = null;

  function moteur() { return window.FVRecherche; }
  // chargement à la demande du moteur (une seule fois ; nouvel essai à la prochaine recherche s'il échoue)
  function chargerMoteur() {
    if (moteur()) return Promise.resolve();
    if (moteurPret) return moteurPret;
    moteurPret = new Promise(function (ok, ko) {
      if (!URL_MOTEUR) { ko(new Error("moteur absent")); return; }
      var s = document.createElement("script");
      s.src = URL_MOTEUR; s.async = true;
      s.onload = function () { if (moteur()) ok(); else ko(new Error("moteur absent")); };
      s.onerror = function () { s.remove(); ko(new Error("moteur absent")); };
      (document.head || document.documentElement).appendChild(s);
    }).catch(function (e) { moteurPret = null; throw e; });
    return moteurPret;
  }
  function charger(frais) {
    if (index && !frais) return Promise.resolve(index);
    if (chargement) return chargement;
    var brut = null;
    if (!frais) try { var m = JSON.parse(sessionStorage.getItem(CLE) || "null"); if (m && Date.now() - m.t < DUREE && Array.isArray(m.l)) brut = m.l; } catch (e) {}
    var avance = window.__fvsIndex; window.__fvsIndex = null; // index parti dès le début de la page de résultats (section fv-recherche)
    var source = brut ? Promise.resolve(brut) : Promise.all([
      (avance || fetchOrig(urlIndex(), { credentials: "same-origin", cache: "no-store" }).then(function (r) { if (!r.ok) throw new Error("index " + r.status); return r.json(); })),
      URL_MOTS ? fetchOrig(URL_MOTS).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }) : Promise.resolve({})
    ]).then(function (res) {
      var l = res[0], mots = res[1] || {};
      l.forEach(function (p) { if (mots[p.h]) p.k = mots[p.h].join("|"); });
      try { sessionStorage.setItem(CLE, JSON.stringify({ t: Date.now(), l: l })); } catch (e) {}
      return l;
    });
    chargement = Promise.all([source, chargerMoteur()]).then(function (res) { // index et moteur en parallèle
      if (!moteur()) throw new Error("moteur absent");
      index = moteur().preparer(res[0]); return index;
    }).catch(function (e) { chargement = null; throw e; });
    return chargement;
  }

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function messageVide(r, q) { // textes validés par Andy (11/10/2026, 17/10/2026)
    if (r.question) return "Le diagnostic de peau t’aide à choisir en 2 minutes.";
    // aucun produit ne répond (marque absente comprise) : on le dit simplement, les produits proches restent affichés
    if (!r.resultats.length) return "Aucun résultat pour « " + nettoyer(q) + " ».";
    return "";
  }
  function prix(c) { return (c / 100).toFixed(2).replace(".", ",") + " €"; }
  function nettoyer(q) { q = String(q || ""); var i = q.lastIndexOf(" AND "); return i > -1 ? q.slice(i + 5) : q; }

  /* ---------- 1. volet de recherche ---------- */
  function ligne(p, n) {
    var img = p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="eager" class="h-full w-full object-cover absolute top-0 left-0 image-hover z-0">' :
      '<div class="bg-[#c9c9c9] absolute top-0 left-0 w-full h-full"></div>';
    var px = p.c > p.p ? '<s class="cap rtl:inline-block price-compare rtl:leading-tight text-[80%]">' + prix(p.c) + '</s> <span class="price-sale ml-1">' + prix(p.p) + "</span>" : '<p class="price">' + prix(p.p) + "</p>";
    return '<li id="predictive-search-option-fv-' + n + '" class="pt-2 pb-2" role="option" aria-selected="false">' +
      '<a href="' + RACINE + "products/" + encodeURIComponent(p.h) + '" class="flex gap-4 relative disable-effect h-full">' +
      '<div class="w-24 relative"><div class="relative overflow-hidden w-full float-left before:h-0 before:block before:pb-[100.0%]">' + img + "</div></div>" +
      '<div class="flex-1"><div class="leading-tight mb-2 uppercase p-break-words tracking-widest text-xs">' + esc(p.v) + "</div>" +
      '<div class="mb-2"><p class="p-break-words leading-tight duration-200 transition hover-text-link text-[rgba(var(--colors-heading))]">' + esc(p.t) + "</p></div>" +
      '<div class=" price leading-none ">' + px + "</div></div></a></li>";
  }
  function titreBloc(id, txt, haut) {
    return '<h2 id="' + id + '" class="predictive-search-heading pl-6 pr-6 lg:pl-10 lg:pr-10 ' + (haut ? "pt-6 lg:pt-7" : "pt-6 md:pt-2") + ' pb-2 uppercase body-text-base-size">' + txt + "</h2>";
  }
  function listeHtml(id, produits, depart) {
    return '<ul role="listbox" aria-labelledby="' + id + '" class="predictive-result-item grid grid-cols-1 gap-2 pl-6 pr-6 lg:pl-10 lg:pr-10 pb-2.5">' +
      produits.map(function (p, k) { return ligne(p, depart + k + 1); }).join("") + "</ul>";
  }
  function liensHtml(liens) { // pilules vers la bonne page (diagnostic, contact, marques)
    return liens.length ? '<div class="pl-6 pr-6 lg:pl-10 lg:pr-10 pt-2 pb-3">' + liens.map(function (l) {
      return '<a href="' + RACINE + l.u + '" style="display:inline-flex;align-items:center;height:36px;padding:0 18px;margin:0 8px 8px 0;border:2px solid #00FFD1;border-radius:999px;color:#141414;text-decoration:none;font:700 13px/1 var(--font-heading-family);text-transform:uppercase;letter-spacing:.02em">' + esc(l.t) + "</a>";
    }).join("") + "</div>" : "";
  }
  function retoucherVolet(html, q, limite, idx) {
    var r = moteur().chercher(idx, q, 48);
    var produits = r.resultats.slice(0, limite), titre2 = "Produits proches";
    var proches = produits.length < limite ? r.proches.slice(0, produits.length ? Math.min(3, limite - produits.length) : limite) : [];
    if (!produits.length && !proches.length) { proches = r.meilleures.slice(0, limite); titre2 = "Best-sellers"; } // jamais un volet vide
    var doc = new DOMParser().parseFromString(html, "text/html");
    var sec = doc.getElementById("shopify-section-predictive-search");
    if (!sec) return html;
    var h2 = doc.getElementById("predictive-search-products");
    if (!produits.length && h2) { // Shopify a trouvé des produits (texte des fiches) : on les garde, avec les liens utiles
      if (r.liens.length) h2.insertAdjacentHTML("beforebegin", liensHtml(r.liens));
      return "<!doctype html><html><body>" + sec.outerHTML + "</body></html>";
    }
    if (!produits.length && !proches.length && !r.liens.length) return html;
    var bloc = liensHtml(r.liens);
    if (!produits.length) bloc = '<p class="predictive-search-heading pl-6 pr-6 lg:pl-10 lg:pr-10 pt-2 pb-3" style="text-transform:none;font-family:inherit;font-weight:400;letter-spacing:normal">' +
      esc(messageVide(r, q) || "Aucun résultat pour « " + nettoyer(q) + " ».") + "</p>" + bloc; // dans tous les cas où rien ne répond
    if (produits.length) bloc += titreBloc("predictive-search-products", "Produits", !!r.liens.length) + listeHtml("predictive-search-products", produits, 0);
    if (proches.length) bloc += titreBloc("predictive-search-proches", titre2, !!(produits.length || r.liens.length)) + listeHtml("predictive-search-proches", proches, produits.length);
    if (h2) {
      var ancien = h2.parentNode; ancien.innerHTML = bloc;
    } else {
      var autres = doc.querySelector(".predictive-search-others");
      var div = doc.createElement("div"); div.className = "flex-1"; div.innerHTML = bloc;
      if (autres) {
        autres.insertBefore(div, autres.firstChild);
        if (div.nextElementSibling && !div.nextElementSibling.classList.contains("line-spacing")) {
          var sep = doc.createElement("div"); sep.className = "line-spacing flex-shrink-0"; autres.insertBefore(sep, div.nextSibling);
        }
      } else {
        var zone = doc.querySelector("#predictive-search-results > div");
        if (!zone) return html;
        var vide = zone.querySelector("[data-predictive-search-live-region-count-value]");
        if (vide) vide.remove(); // le message « Aucun résultat pour… » est déjà en tête du bloc
        autres = doc.createElement("div"); autres.className = "predictive-search-results-list predictive-search-others lg:w-3/4";
        autres.appendChild(div); zone.appendChild(autres);
        if (!zone.className) zone.className = "content-results-horizontal";
        var cadre = doc.querySelector("#shopify-section-predictive-search > div");
        if (cadre && !cadre.querySelector(":scope > button")) {
          cadre.classList.remove("pb-7");
          var b = doc.createElement("button");
          b.className = "background-header shadow-[0_0_6px_-4px_rgba(var(--colors-text))] pt-5 pb-5 pl-6 pr-6 lg:pl-9 lg:pr-9 border-solid rounded-none inline-block cursor-pointer hover-text-link text-center w-full text-current border-t";
          b.textContent = "Voir tout";
          cadre.appendChild(b);
        }
      }
    }
    return "<!doctype html><html><body>" + sec.outerHTML + "</body></html>";
  }
  window.fetch = function (entree, options) {
    var url = typeof entree === "string" ? entree : (entree && entree.url) || "";
    if (url.indexOf("search/suggest") === -1 || url.indexOf("section_id=predictive-search") === -1) return fetchOrig(entree, options);
    var u; try { u = new URL(url, location.origin); } catch (e) { return fetchOrig(entree, options); }
    var q = nettoyer(u.searchParams.get("q")), limite = parseInt(u.searchParams.get("resources[limit]"), 10) || 6;
    // prix à jour : la réponse de Shopify n'est jamais reprise du cache du navigateur
    var opts = Object.assign({}, options || {}, { cache: "no-store" });
    return Promise.all([fetchOrig(typeof entree === "string" ? entree : url, opts), charger().catch(function () { return null; })]).then(function (res) {
      var rep = res[0], idx = res[1];
      if (!idx || !rep.ok) return rep;
      return rep.text().then(function (html) {
        try { html = retoucherVolet(html, q, limite, idx); } catch (e) {}
        return new Response(html, { status: 200, headers: { "Content-Type": "text/html; charset=utf-8" } });
      });
    });
  };
  // l'index se charge dès qu'on approche de la recherche (survol de la loupe, champ de saisie)
  function precharger(e) {
    var t = e.target;
    if (t && t.closest && t.closest('input[type="search"], input[name="q"], [aria-label*="echerch"], [aria-label*="earch"], .fvs')) charger().catch(function () {});
  }
  document.addEventListener("focusin", precharger, true);
  document.addEventListener("pointerover", precharger, true);

  /* ---------- 2. page de résultats ---------- */
  /* fiveaven 20/10/2026 : 12 cartes demandées à la fois (au lieu de 6) ; chaque carte reçue est gardée 1 min dans le navigateur
     (prix à jour : jamais plus d'1 min) ; en attendant la vraie carte, une carte simple tirée de l'index (photo, marque, nom, prix). */
  var PAR_PAGE = 24, PARALLELES = 12, cartes = {}, CLE_CARTE = "fv-carte-v1:";
  function carte(h) { // carte produit identique aux collections, rendue par la section fv-carte-recherche
    if (!cartes[h]) {
      try { var m = JSON.parse(sessionStorage.getItem(CLE_CARTE + h) || "null"); if (m && Date.now() - m.t < DUREE && m.html) cartes[h] = Promise.resolve(m.html); } catch (e) {}
    }
    if (!cartes[h]) cartes[h] = fetchOrig(RACINE + "products/" + encodeURIComponent(h) + "?section_id=fv-carte-recherche", { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var d = new DOMParser().parseFromString(t, "text/html"); var g = d.querySelector(".grid-item"); var html = g ? g.outerHTML : "";
        if (html) try { sessionStorage.setItem(CLE_CARTE + h, JSON.stringify({ t: Date.now(), html: html })); } catch (e) {}
        return html; })
      .catch(function () { delete cartes[h]; return ""; });
    return cartes[h];
  }
  function apercu(p) { // carte simple en attendant la vraie (mêmes proportions que la case)
    if (!p.i) return "";
    return '<a class="fvs__pre" href="' + RACINE + "products/" + encodeURIComponent(p.h) + '"><span class="fvs__pre-img"><img src="' + esc(p.i) + '" alt="" decoding="async"></span>' +
      '<span class="fvs__pre-txt"><span class="fvs__pre-v">' + esc(p.v) + '</span><span class="fvs__pre-t">' + esc(p.t) + '</span>' + (p.p != null ? '<span class="fvs__pre-p">' + prix(p.p) + "</span>" : "") + "</span></a>";
  }
  function remplir(conteneur, produits) {
    var cases = produits.map(function (p) {
      var c = document.createElement("div"); c.className = "fvs__case"; c.setAttribute("data-h", p.h); c.innerHTML = apercu(p); conteneur.appendChild(c); return { c: c, p: p };
    });
    var i = 0;
    function suivant() {
      if (i >= cases.length) return Promise.resolve();
      var x = cases[i++];
      return carte(x.p.h).then(function (html) {
        if (html && x.c.parentNode) { var t = document.createElement("div"); t.innerHTML = html; x.c.replaceWith(t.firstElementChild); }
        else if (x.c.parentNode) x.c.remove();
      }).then(suivant);
    }
    var lots = []; for (var k = 0; k < PARALLELES; k++) lots.push(suivant());
    return Promise.all(lots);
  }

  function page() {
    // fiveaven : seulement sur la page de résultats (racine data-fvs) ; ailleurs (page panier comprise) rien ne s'exécute
    var R = document.querySelector("[data-fvs]"); if (!R) return;
    var q = nettoyer(R.getAttribute("data-q")).trim();
    var grille = R.querySelector("[data-fvs-grille]"), compte = R.querySelector("[data-fvs-compte]"), filtres = R.querySelector("[data-fvs-filtres]");
    var suite = R.querySelector("[data-fvs-suite]"), vide = R.querySelector("[data-fvs-vide]"), blocProches = R.querySelector("[data-fvs-bloc-proches]");
    var bascule = R.querySelector("[data-fvs-bascule]"), basculeTxt = R.querySelector("[data-fvs-bascule-txt]");
    if (!grille || !compte || !filtres || !suite || !vide || !blocProches || !bascule || !basculeTxt) return; // gabarit incomplet : on ne casse rien
    var shopify = []; try { shopify = JSON.parse(R.querySelector("[data-fvs-shopify]").textContent || "[]"); } catch (e) {}
    var mobile = window.matchMedia("(max-width: 767px)");
    var etat = { tous: [], proches: [], meilleures: [], message: "", choix: { v: {}, ty: {} }, affiches: 0, liste: [] };
    var liensBloc = R.querySelector("[data-fvs-liens]"), titreProches = R.querySelector("[data-fvs-t2]");
    var GROUPES = [["v", "Marques"], ["ty", "Type de soin"]];

    function ouvert(o) {
      R.classList.toggle("fvs--sans-filtres", !o);
      bascule.setAttribute("aria-expanded", o ? "true" : "false");
      basculeTxt.textContent = o ? "Masquer les filtres" : "Afficher les filtres";
    }
    bascule.addEventListener("click", function () { ouvert(R.classList.contains("fvs--sans-filtres")); });
    ouvert(!mobile.matches);

    function filtrer() {
      return etat.tous.filter(function (p) {
        return GROUPES.every(function (g) { var c = etat.choix[g[0]]; return !Object.keys(c).length || c[p[g[0]] || ""]; });
      });
    }
    function nbChoix() { return GROUPES.reduce(function (n, g) { return n + Object.keys(etat.choix[g[0]]).length; }, 0); }
    function construireFiltres() {
      var html = "";
      GROUPES.forEach(function (g) {
        var n = {}; etat.tous.forEach(function (p) { var v = p[g[0]]; if (v) n[v] = (n[v] || 0) + 1; });
        var vals = Object.keys(n).sort(function (a, b) { return a.localeCompare(b, "fr", { sensitivity: "base" }); });
        if (vals.length < 2) return;
        html += '<div class="fvs__groupe" data-g="' + g[0] + '"><button type="button" class="fvs__groupe-t" aria-expanded="true"><span>' + g[1] + '</span>' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="none" d="M23 7L12 18L0.999999 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<ul class="fvs__valeurs' + (g[0] === "v" ? " fvs__valeurs--defile" : "") + '">' + vals.map(function (v, k) {
            var id = "fvs-" + g[0] + "-" + k;
            return '<li><label for="' + id + '"><input type="checkbox" id="' + id + '" value="' + esc(v) + '"' + (etat.choix[g[0]][v] ? " checked" : "") + "><span>" + esc(v) + "</span></label></li>";
          }).join("") + "</ul></div>";
      });
      if (html) html += '<button type="button" class="fvs__reinit" data-fvs-reinit' + (nbChoix() ? "" : " hidden") + ">Réinitialiser les filtres</button>";
      filtres.innerHTML = html;
      bascule.hidden = !html;
      if (!html) R.classList.add("fvs--sans-filtres");
    }
    filtres.addEventListener("change", function (e) {
      var i = e.target; if (!i.matches('input[type="checkbox"]')) return;
      var g = i.closest("[data-g]").getAttribute("data-g");
      if (i.checked) etat.choix[g][i.value] = 1; else delete etat.choix[g][i.value];
      var r = filtres.querySelector("[data-fvs-reinit]"); if (r) r.hidden = !nbChoix();
      afficher();
    });
    filtres.addEventListener("click", function (e) {
      var t = e.target.closest(".fvs__groupe-t");
      if (t) { var o = t.getAttribute("aria-expanded") !== "true"; t.setAttribute("aria-expanded", o ? "true" : "false"); t.parentNode.classList.toggle("fvs__groupe--ferme", !o); return; }
      if (e.target.closest("[data-fvs-reinit]")) { etat.choix = { v: {}, ty: {} }; construireFiltres(); afficher(); }
    });

    function afficher() {
      etat.liste = filtrer(); etat.affiches = 0;
      grille.innerHTML = "";
      var n = etat.liste.length;
      compte.textContent = n ? n + (n > 1 ? " produits" : " produit") : "";
      vide.hidden = !!n || etat.message === "-";
      if (!n) vide.innerHTML = etat.message ? "<p>" + esc(etat.message) + "</p>" :
        '<p>Aucun résultat pour « ' + esc(q) + ' ». Vérifie l’orthographe ou essaie un autre mot.</p><a class="fvs__bouton" href="' + RACINE + 'collections/all">Voir tous les produits</a>';
      plus();
      var autres = etat.proches.length ? etat.proches : etat.meilleures; // en dernier recours : les best-sellers
      var avecProches = !nbChoix() && autres.length && etat.tous.length < 8;
      blocProches.hidden = !avecProches;
      if (titreProches) titreProches.textContent = etat.proches.length ? "Produits proches" : "Best-sellers";
      var gp = blocProches.querySelector("[data-fvs-proches]"); gp.innerHTML = "";
      if (avecProches) remplir(gp, autres);
    }
    var occupe = false;
    function plus() {
      if (occupe || etat.affiches >= etat.liste.length) return;
      occupe = true;
      var lot = etat.liste.slice(etat.affiches, etat.affiches + PAR_PAGE); etat.affiches += lot.length;
      remplir(grille, lot).then(function () { occupe = false; verifierSuite(); });
    }
    function verifierSuite() { var r = suite.getBoundingClientRect(); if (r.top < window.innerHeight + 600) plus(); }
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) plus(); }, { rootMargin: "600px 0px" }).observe(suite);
    else window.addEventListener("scroll", verifierSuite, { passive: true });

    function demarrer(liste, proches, liens, meilleures, message) {
      etat.tous = liste; etat.proches = proches || []; etat.meilleures = meilleures || []; etat.message = message || "";
      if (liensBloc && liens && liens.length) {
        var question = etat.message && !liste.length && liens.some(function (l) { return l.u.indexOf("diagnostic") > -1; });
        liensBloc.innerHTML = (question ? '<p class="fvs__liens-texte">' + esc(etat.message) + "</p>" : "") +
          liens.map(function (l) { return '<a class="fvs__lien" href="' + RACINE + l.u + '">' + esc(l.t) + "</a>"; }).join("");
        liensBloc.hidden = false;
        if (question) etat.message = "-"; // le texte est déjà au-dessus de la pilule : rien sous le titre
      }
      construireFiltres(); afficher();
    }
    if (!q) { compte.textContent = ""; bascule.hidden = true; R.classList.add("fvs--sans-filtres"); return; }
    charger().then(function (idx) { // index de moins d'1 min réutilisé (chargé par la loupe ou dès le début de la page)
      var r = moteur().chercher(idx, q, 96);
      if (r.resultats.length || !shopify.length) return demarrer(r.resultats, r.proches, r.liens, r.meilleures, messageVide(r, q));
      var parH = {}; idx.forEach(function (o) { parH[o.p.h] = o.p; }); // le moteur ne trouve rien mais Shopify oui (texte des fiches)
      demarrer(shopify.map(function (s) { return parH[s.h] || s; }), r.proches, r.liens, []);
    }).catch(function () { demarrer(shopify, []); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", page); else page();
})();
